module.exports = __webpack_public_path__ + "img/hxkj-jjfa-3.c9775a5e.svg";